/**
 * `any` is used intentionally throughout this file.
 *
 * The factory copies arbitrary keys from `window.__env` (a plain JS object written by a
 * per-environment script at deploy time) onto a concrete EnvService instance.
 */
import { FactoryProvider, Type } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Environment = { [key: string]: any };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const envServiceFactory = (env: Environment) => () => {
  // Read environment variables from browser window
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const browserWindow: { [key: string]: any } = window || {};
  const browserWindowEnv: Environment = browserWindow['__env'] || {};

  // Assign environment variables from browser window to env
  // In the current implementation, properties from env.js overwrite defaults from the EnvService.
  // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
  for (const key in browserWindowEnv) {
    if (Object.prototype.hasOwnProperty.call(browserWindowEnv, key)) {
      env[key] = browserWindowEnv[key];
    }
  }

  return env;
};

export const envServiceProvider: <T extends Type<Environment>>(
  envService: T
) => FactoryProvider = <T extends Type<Environment>>(envService: T) => ({
  provide: envService,
  useFactory: envServiceFactory(new envService()),
});
